import { splitProps } from 'solid-js'

type Props = ComponentProps<'section'>

export function Section(props: Props) {
  return <Presenter {...props} />
}

function Presenter(props: Props) {
  const [component, attributes] = splitProps(props, ['children'])
  return <section {...attributes}>{component.children}</section>
}
